import moment from "moment";
import { ItemEnum } from "./ItemEnum";
import { MBase } from "./MBase";

export class Equipamento extends MBase {
    Id: number;
    Descricao:string = "";
    Potencia: number = 0;
    DoseTanque: number = 0;
    UnidadeMedida:string = "";
    VidaUtilHoras: number = 0;
    GrupoEquipamentoId: number;
    TipoMedidor: EnumTipoMedidorEquipamento;
    LimiteDiarioKm: number = 0;
    AtividadeId: number;
    MedidorInicial: number = 0;
    FlagImplemento: boolean;
    ProcessoPlanejamento:string = "";
    _processoPlanejamento: number[] = [];
    UsaImplemento: boolean;

    NSerie:string = "";
    Marca:string = "";
    Modelo:string = "";
    TAG:string = "";
    Chassi:string = "";
    Placa:string = "";
    LarguraTrabalho: number = 0;
    CapacidadeCombustivel: number;
    Consumo: number;
    TipoCombustivel: EnumTipoCombustivelEquipamento;
    ValorAquisicao: number = 0;
    ValorResidual: number = 0;
    Ativo: boolean = true;

    IdIrrigaPrime:string = "";
    CorRotaIrrigaPrime:string = "";
    IconeIrrigaPrime:string = "";
    IconeIrrigaPrimeBase64:string = "";
    Tag:string = "";
    ClasseId: number;

    UsuarioAlteracaoDesc:string = "";
    GrupoEquipamentoDesc:string = "";

      get descAtivo(): string{
      return this.Ativo ? 'Ativo' : 'Inativo'
    }

    get dataAlteracaoStr(): string{
      let texto =  moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm');
      console.log('dataAlteracaoStr', texto);
      return texto;
    }

    TipoCombustivelDesc: string = "";
    DataAlteracaoFilter: Date;
    AtivoDesc: string = "";
}

export enum EnumTipoMedidorEquipamento
{
    NaoInformado = 0,
    Horimetro = 1,
    Hodometro =2
}
export enum EnumTipoCombustivelEquipamento
{
    NaoInformado = 0,
    Diesel = 1,
    Gasolina = 2,
    Biodiesel = 3,
    Etanol = 4,
    GNV = 5
}
export const TiposMedidorEquipamento: ItemEnum[] = [
    {name: 'Nenhum', value: EnumTipoMedidorEquipamento.NaoInformado},
    {name: 'Horímetro', value: EnumTipoMedidorEquipamento.Horimetro},
    {name: 'Km', value: EnumTipoMedidorEquipamento.Hodometro},
  ];

  export const TiposCombustivelEquipamento: ItemEnum[] = [
    {name: 'Nenhum', value: EnumTipoCombustivelEquipamento.NaoInformado},
    {name: 'Diesel', value: EnumTipoCombustivelEquipamento.Diesel},
    {name: 'Gasolina', value: EnumTipoCombustivelEquipamento.Gasolina},
    {name: 'Biodiesel', value: EnumTipoCombustivelEquipamento.Biodiesel},
    {name: 'Etanol', value: EnumTipoCombustivelEquipamento.Etanol},
    {name: 'GNV', value: EnumTipoCombustivelEquipamento.GNV},
  ];
